module.exports = __webpack_public_path__ + "img/team3.7b781168.jpg";